import React, { useEffect, useState } from "react";
import OthersOutfitListView from "presentational/portfolio/OthersOutfitListView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

OthersOutfitListForUser.propTypes = {
  ownerName: PropTypes.string.isRequired
};

function OthersOutfitListForUser(props) {
  const {
    ownerName,
    isLoading,
    isEnd,
    outfitList,
    OthersOutfitForUserActions,
    AppErrorActions,
    getIdTokenWT
  } = props;
  const [nowOwnerName, setNowOwnerName] = useState(null);

  useEffect(() => {
    changeOwnerName();
  });

  const changeOwnerName = async () => {
    if (ownerName === nowOwnerName) return null;
    setNowOwnerName(ownerName);

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    try {
      await OthersOutfitForUserActions.changeUser({ name: ownerName, idToken });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleClick = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    try {
      await OthersOutfitForUserActions.getList({ idToken });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <OthersOutfitListView
      list={outfitList}
      isLoading={isLoading}
      isEnd={isEnd}
      callNextListFn={handleClick}
    />
  );
}

export default withStore({
  stateMap: {
    othersOutfitForUser: ["outfitList", "isLoading", "isEnd"]
  },
  dispatchMap: ["othersOutfitForUser", "appError"]
})(withToken(OthersOutfitListForUser));
